import React from 'react'
import { useTranslation } from 'react-i18next'
import { TextField, Grid, Box, MenuItem } from '@mui/material'

import { useUsersFilters } from '@/views/users/hooks/use-users-filters.hook'
import { RoleType } from '@/enums/role.enum'
import { mapEnum } from '@/utils'

export const UsersFilters = () => {
  const { t } = useTranslation()

  const { filters, handleChangeSearch } = useUsersFilters()

  const roleOptions = mapEnum(RoleType, (index: RoleType) => {
    return (
      <MenuItem key={index} value={index}>
        {t(`roleType.${RoleType[index as RoleType]}`)}
      </MenuItem>
    )
  })

  return (
    <Box borderRadius={10}>
      <Grid container spacing={1} alignItems="flex-end">
        <Grid item xs={12} md={4} lg={2}>
          <TextField
            autoComplete="off"
            fullWidth
            name="firstName"
            margin="dense"
            variant="outlined"
            label={t('firstName')}
            value={filters?.firstName || ''}
            onChange={(e: React.ChangeEvent<{ value: string }>) => {
              handleChangeSearch('firstName', e.target.value, true)
            }}
            InputProps={{
              inputProps: {
                maxLength: 100,
              },
            }}
          />
        </Grid>
        <Grid item xs={12} md={4} lg={2}>
          <TextField
            autoComplete="off"
            fullWidth
            name="lastName"
            margin="dense"
            variant="outlined"
            label={t('lastName')}
            value={filters?.lastName || ''}
            onChange={(e: React.ChangeEvent<{ value: string }>) => {
              handleChangeSearch('lastName', e.target.value, true)
            }}
            InputProps={{
              inputProps: {
                maxLength: 100,
              },
            }}
          />
        </Grid>
        <Grid item xs={12} md={4} lg={2}>
          <TextField
            autoComplete="off"
            fullWidth
            name="username"
            margin="dense"
            variant="outlined"
            label={t('labels.username')}
            value={filters?.username || ''}
            onChange={(e: React.ChangeEvent<{ value: string }>) => {
              if (e.nativeEvent instanceof InputEvent) {
                handleChangeSearch('username', e.target.value, true)
              }
            }}
            InputProps={{
              inputProps: {
                maxLength: 100,
              },
            }}
          />
        </Grid>
        <Grid item xs={12} md={4} lg={2}>
          <TextField
            autoComplete="off"
            fullWidth
            name="email"
            margin="dense"
            variant="outlined"
            label={t('email')}
            value={filters?.email || ''}
            onChange={(e: React.ChangeEvent<{ value: string }>) => {
              handleChangeSearch('email', e.target.value, true)
            }}
            InputProps={{
              inputProps: {
                maxLength: 100,
              },
            }}
          />
        </Grid>
        <Grid item xs={12} md={4} lg={2}>
          <TextField
            fullWidth
            name="role"
            margin="dense"
            label={t('roles')}
            value={filters?.role || ''}
            onChange={(e: React.ChangeEvent<{ value: string }>) => {
              handleChangeSearch('role', e.target.value)
            }}
            select
          >
            <MenuItem value="">
              <Box fontStyle="italic">{t('all')}</Box>
            </MenuItem>
            {roleOptions}
          </TextField>
        </Grid>
      </Grid>
    </Box>
  )
}
